import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Globe, Phone, Mail, MapPin } from "lucide-react";
import api from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";
import { Button } from "@/components/ui/button";

export default function AgencyDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { api.get(`/agencies/${slug}`).then((r) => setA(r.data)).catch(() => setNf(true)); }, [slug]);

  if (nf) return <div className="max-w-3xl mx-auto px-5 py-24 text-center"><h1 className="font-display text-3xl font-bold">Agency not found</h1><Link to="/agencies"><Button className="mt-6 rounded-full bg-[#C81D35] hover:bg-[#a5162b]">All agencies</Button></Link></div>;
  if (!a) return <div className="max-w-6xl mx-auto px-5 py-14 animate-pulse"><div className="h-40 bg-muted rounded-2xl" /></div>;

  return (
    <div>
      <div className="bg-[#111827] py-16">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 flex items-center gap-6">
          {a.logo ? <img src={a.logo} alt={a.name} className="w-20 h-20 rounded-2xl object-contain bg-white p-2" /> : <div className="w-20 h-20 rounded-2xl bg-[#C81D35] text-white flex items-center justify-center text-3xl font-bold font-display">{a.name?.[0]}</div>}
          <div>
            <h1 className="font-display text-4xl font-bold text-white tracking-tight">{a.name}</h1>
            <div className="mt-3 flex flex-wrap gap-4 text-sm text-white/80">
              {a.public_phone && <span className="flex items-center gap-2"><Phone className="w-4 h-4" /> {a.public_phone}</span>}
              {a.public_email && <span className="flex items-center gap-2"><Mail className="w-4 h-4" /> {a.public_email}</span>}
              {a.website && <a href={a.website} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><Globe className="w-4 h-4" /> Website</a>}
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
        {a.description && <p className="text-lg text-[#111827]/80 max-w-3xl">{a.description}</p>}
        {a.service_areas?.length > 0 && <p className="mt-4 text-sm text-muted-foreground flex items-center gap-2"><MapPin className="w-4 h-4" /> Covering {a.service_areas.join(", ")}</p>}
        <h2 className="mt-12 font-display text-2xl font-bold text-[#111827]">Properties from {a.name}</h2>
        {a.properties?.length > 0 ? (
          <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{a.properties.map((p) => <PropertyCard key={p.id} property={p} />)}</div>
        ) : (
          <p className="mt-4 text-muted-foreground" data-testid="agency-no-props">No properties currently listed from this partner.</p>
        )}
      </div>
    </div>
  );
}
